<template>
  <div
    id="app-header"
    class="demo__Header demo__flex demo__margin-bottom-mobile--3 animated fadeIn"
  >
    <div
      class="demo__flex demo__flex-space-around demo__flex-middle demo__flex-full"
    >
      <div class="demo__flex demo__flex-between demo__flex-full">
        <div class="demo__flex demo__flex-middle">
          <ClientMeta class="demo__margin-right--20" />
        </div>
        <div class="demo__flex demo__flex-middle" v-if="!isMobile">
          <BaseMenu :window-width="windowWidth" />
        </div>
        <div
          class="demo__flex demo__flex-middle demo__flex-end"
          v-bind:class="{
            'demo__min-width--150': !isMobile,
          }"
        >
          <div v-if="langs.length > 1">
            <LangSelector />
          </div>
          <div
            v-if="userIsBaseSub && $root.showLogic"
            class="demo__margin-left--22"
          >
            <SubButton />
          </div>
          <div
            v-if="!isMobile"
            class="demo__flex demo__flex-middle demo__margin-left--22 demo__flex-end"
          >
            <Profile />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import BaseMenu from "./components/BaseMenu";
import ClientMeta from "./components/ClientMeta";
import Profile from "./components/Profile";
import SubButton from "Components/SubButton";

import LangSelector from "./components/Lang";

export default {
  components: {
    ClientMeta,
    BaseMenu,
    Profile,
    SubButton,
    LangSelector,
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      showShare: true,
      requiredShare: true,
    };
  },
  computed: {
    ...mapGetters(["user", "module", "isMobile", "userIsBaseSub", "langs"]),
    localhost() {
      return window.location.hostname === "localhost" ? true : false;
    },
    _isMobile() {
      return this.$route.path.indexOf("view") === -1
        ? this.isMobile
        : this.windowWidth <= 1024;
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
    this.$root.$off("setShowShare", this.setShowShare);
  },
  created() {
    this.$accessModule("header_component", this);
    this.$root.$on("setShowShare", this.setShowShare);

    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    setShowShare(showShare) {
      this.showShare = showShare;
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    async onloadAnnotationsJson(e) {
      const annotations = await this.parseJsonFile(e.target.files[0]);

      this.$root.$emit("setAnnotations", annotations);
    },
    parseJsonFile(file) {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.onload = (event) => resolve(JSON.parse(event.target.result));
        fileReader.onerror = (error) => reject(error);
        fileReader.readAsText(file);
      });
    },
  },
};
</script>
